import React, { useContext, useEffect, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import { Link } from "react-router-dom";

export function Offers() {
  const { user } = useContext(AuthContext);
  const [ofertas, setOfertas] = useState([]);

  useEffect(() => {
    const fetchOfertas = async () => {
      try {
        const token = localStorage.getItem("token");
        const res = await fetch(`${process.env.REACT_APP_API_URL}/api/admin/ofertas`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        if (!res.ok) throw new Error("Erro ao buscar ofertas");

        const data = await res.json();
        setOfertas(data);
      } catch (error) {
        console.error("Erro ao carregar ofertas:", error);
      }
    };

    fetchOfertas();
  }, []);

  if (!user) {
    return (
      <div className="text-center max-w-md mx-auto bg-white shadow p-6 rounded mt-10">
        <h1 className="text-2xl font-bold mb-4">Acesso Restrito</h1>
        <p className="text-red-500 mb-4">É necessário efetuar login para acessar as ofertas.</p>
        <Link to="/login" className="text-blue-600 font-medium hover:underline">
          Ir para Login
        </Link>
      </div>
    );
  }

  return (
    <div className="bg-gray-50 min-h-screen py-10 px-4">
      <h1
        className="text-3xl md:text-4xl font-bold text-center mb-10"
        style={{ fontFamily: "Montserrat, sans-serif" }}
      >
        Ofertas Disponíveis
      </h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
        {ofertas.map((oferta) => (
          <Link
            to={`/cupom/${oferta.codigoPromocional}`}
            key={oferta.id}
            className="bg-white p-6 rounded-xl shadow-md flex flex-col items-center border border-gray-200 hover:shadow-lg transition cursor-pointer"
          >
            <img
              src={oferta.imagemUrl}
              alt={oferta.nome}
              className="h-32 w-32 object-contain mb-4"
            />
            <h2 className="text-xl font-normal text-gray-800 mb-1">{oferta.nome}</h2>
            <p className="text-sm text-gray-600 mb-4">
              <span className="font-bold">
                R${Number(oferta.cashback).toFixed(2).replace(".", ",")} de cashback
              </span>{" "}
            </p>
            <button
              className="bg-blue-700 hover:bg-blue-800 text-white px-6 py-2 rounded-full text-sm font-medium transition"
              style={{ pointerEvents: "none" }}
            >
              Ganhar Cashback!
            </button>
          </Link>
        ))}
      </div>
    </div>
  );
}
